import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/search/loading.js");
